import React, { useState } from "react";
import IfSamePathThenScrollToTop from "../../Utility/IfSamePathThenScrollToTop";
import "./Footer.scss";
import { NavLink } from "react-router-dom";
import { NavHashLink } from 'react-router-hash-link';
import facebook from "../../../assets/images/icons/Facebook-knockout.svg";
import linkedin from "../../../assets/images/icons/LinkedIn-knockout.svg";
import twitter from "../../../assets/images/icons/Twitter-knockout.svg";
import instagram from "../../../assets/images/icons/Insta-knockout.svg";


const NewFooter = () => {
  const [userEmail, setUserEmail] = useState("");
  return (
    <div className="footerContainer p-2 pt-4 p-md-5" >
      <div className="row max-footer-width mb-5">
        <div className="col-12 col-lg-7">
          <div className="footerGroups">

          <div className="row1">

          <div className="solutionGroup ">
              <h6 className="text-muted">SOLUTIONS</h6>
              <div className="footerItems text-white flex-col">
                <NavHashLink to="/#caseStudies">Case Studies</NavHashLink>
                <a href="https://wordpress.org/plugins/causalfunnel-datascience/?utm_source=CausalFunnel" target="_blank" rel="noreferrer noopener"> Wordpress App </a>
                <a href="https://marketplace.magento.com/causalfunnel-datascience-persona.html?utm_source=CausalFunnel" target="_blank" rel="noreferrer noopener"> Adobe Magento App </a>
                <a href="https://apps.shopify.com/causalfunnel-datascience?utm_source=CausalFunnel" target="_blank" rel="noreferrer noopener"> Shopify App </a>
                <a href="https://www.conversiongrader.com/?utm_source=CausalFunnel" target="_blank" rel="noreferrer noopener"> Conversion Grader </a>
                {/* <NavHashLink to="/platform#insights">Insights</NavHashLink> */}
              </div>
            </div>
            <div className="companyGroup ">
              <h6 className="text-muted">COMPANY</h6>
              <div className="footerItems text-white flex-col">
                {/* <NavLink onClick={(e)=>{IfSamePathThenScrollToTop(e)}} to="/platform">Platform</NavLink> */}
                <NavHashLink  to="/platform#platform">Platform</NavHashLink>
                <NavHashLink to="/company#partners">Partners</NavHashLink>
                <NavHashLink to="/company#press">Press</NavHashLink>

                <a href="https://www.blog.causalfunnel.com"> Blog </a>
              </div>
            </div>

          </div>

        <div className="row2">

            <div className="supportGroup ">
              <h6 className="text-muted">SUPPORT</h6>
              <div className="footerItems text-white flex-col">
                {/* <NavLink onClick={(e)=>{IfSamePathThenScrollToTop(e)}} to="/pricing">Pricing</NavLink> */}
                {/* <NavLink onClick={(e)=>{IfSamePathThenScrollToTop(e)}} to="/faq">FAQ</NavLink> */}
                {/* <NavLink onClick={(e)=>{IfSamePathThenScrollToTop(e)}} to="/contact-us">Contact Us</NavLink> */}
                <NavHashLink to="/pricing#pricing">Pricing</NavHashLink>
                <NavHashLink  to="/faq#faq">FAQ</NavHashLink>
                <NavHashLink  to="/contact-us#contact-us">Contact Us</NavHashLink>
                <NavHashLink to="/company#hiring">Jobs</NavHashLink>
              </div>
            </div>
            <div className="legalGroup ">
              <h6 className="text-muted">LEGAL</h6>
              <div className="footerItems text-white flex-col">
                {/* <NavLink onClick={(e)=>{IfSamePathThenScrollToTop(e)}} to="/privacy">Privacy</NavLink> */}
                <NavHashLink  to="/privacy#privacy">Privacy</NavHashLink>
                <NavHashLink to="/privacy#terms">Terms</NavHashLink>
                <NavHashLink to="/privacy#claim">Claim</NavHashLink>
              </div>
            </div>

            </div>
          </div>
        </div>
        <div className="col-12 col-lg-5">
          <div className="subscribeGroup p-4">
            <div className="subscribeText">
              <h6 className="text-muted ">SUBSCRIBE TO OUR NEWSLETTER</h6>
              <p className="text-white funnelText">
                Get funnel optimization insights delivered to your inbox!
              </p>
            </div>

            <div className="emailSendGroup flex">
              <div className="me-3 subscribe-Email-BTN">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="emaiInput"
                  value={userEmail}
                  onChange={(e) => setUserEmail(e.target.value)}
                />
              </div>
              <div className="subscribeBTN flex">
                <a
                  className="arrowspan"
                  type="submit"
                  style={{ cursor: "pointer" }}
                  href={`mailto:hi@causalfunnel.com?cc=abhimanu@causalfunnel.com, brian@causalfunnel.com&subject=CausalFunnel Subscription Request&body=Hello, I would like to subscribe to CausalFunnel Insights using my email ${userEmail}.`}
                >
                  <div className="text-white">Subscribe</div>
                </a>
              </div>            
            </div>
          </div>
        </div>
      </div>
      <hr className="text-white "/>
      <div className="right-socialIcon-groups">
        <div className="copyrightContainer">
          <p className="text-muted">© 2022 CausalFunnel,  All rights reserved.</p>
        </div>
        <div className="social-sites-group">
          <div className="social-media-icons text-center pt-3 pt-sm-2 pb-4">
              <ul className="pl-0 pl-md-5 list-inline ">
                <li className="list-inline-item">
                  <a
                    href="https://www.facebook.com/CausalFunnel "
                    target="_blank" rel="noreferrer"
                  >
                    <img src={facebook} alt="CausalFunnel's Facebook Account" />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="https://instagram.com/causalfunnel " target="_blank" rel="noreferrer">
                    <img
                      src={instagram}
                      alt="CausalFunnel's Instagram Account"
                    />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    href="https://www.linkedin.com/company/causalfunnel"
                    target="_blank" rel="noreferrer"
                  >
                    <img src={linkedin} alt="CausalFunnel's LinkedIn Account" />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="https://twitter.com/CausalFunnel " target="_blank" rel="noreferrer">
                    <img src={twitter} alt="CausalFunnel's Twitter Account" />
                  </a>
                </li>
              </ul>
          </div>
        </div>
      </div>
    </div>
  );
};




export default NewFooter;
